import type { SelectionPopupProps } from "./components/SelectionPopup";
import type * as lazyIndex from "./lazyIndex";
import { LazyAction, createLazyComponent, LazyModule, type LazyComponent } from "owa-bundling";
import getSelectionStore from "./store/store";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "SelectionPopup"*/ "./lazyIndex"), { name: "SelectionPopup" });

export const SelectionPopup: LazyComponent<SelectionPopupProps, unknown, void> = createLazyComponent(lazyModule, m => m.SelectionPopup, undefined, undefined, {
    onlyImportIf: () => getSelectionStore().showPopup,
});

export const lazyOnSelectionMade: LazyAction<typeof lazyIndex.onSelectionMade, typeof lazyModule> = new LazyAction(lazyModule, m => m.onSelectionMade);
export const lazyDismissPopup: LazyAction<typeof lazyIndex.dismissPopup, typeof lazyModule> = new LazyAction(lazyModule, m => m.dismissPopup);
